import { useMsal } from '@azure/msal-react';
import { BlockStack, Button, Card, Typography, useTheme } from '@pv-frontend/ui-components-web';
import { loginRequest } from '../auth/msal-config';
import { Centered } from './centered';
import logoLight from '../assets/logo-light.png';
import logoDark from '../assets/logo-dark.png';

/** Unauthenticated landing — starts the Entra redirect sign-in. */
export function LoginScreen() {
    const { instance } = useMsal();
    const { resolvedColorScheme } = useTheme();
    const logo = resolvedColorScheme === 'dark' ? logoLight : logoDark;

    return (
        <Centered>
            <Card padding="700">
                <BlockStack gap="500" inlineAlign="center">
                    <img src={logo} alt="" width={48} height={48} style={{ display: 'block' }} />
                    <BlockStack gap="100" inlineAlign="center">
                        <Typography variant="heading-lg" as="h1">
                            PropertyVault Admin
                        </Typography>
                        <Typography variant="body-sm" tone="text-secondary">
                            Sign in with your operator account to continue.
                        </Typography>
                    </BlockStack>
                    <Button size="slim" onPress={() => void instance.loginRedirect(loginRequest)}>
                        Sign in with Microsoft
                    </Button>
                </BlockStack>
            </Card>
        </Centered>
    );
}
